import React from 'react';
import { Redirect, Route } from 'react-router';
import PropTypes from 'prop-types';
import AnalyticsRoute from './AnalyticsRoute';

const ProtectedRoute = ({
  component: Component,
  condition,
  elseRoute,
  ...rest
}) =>
  condition() ? (
    <AnalyticsRoute component={ Component } { ...rest } />
  ) : (
    <Route { ...rest } render={ () => <Redirect to={ elseRoute } /> } />
  );

ProtectedRoute.propTypes = {
  component: PropTypes.func,
  condition: PropTypes.func,
  elseRoute: PropTypes.string
};

ProtectedRoute.defaultProps = {
  component: null,
  condition: () => true,
  elseRoute: '/'
};

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/utils/ProtectedRoute.js